module.exports = __webpack_public_path__ + "img/国防科技大学军政基础教育学院.8f8aa9f9.png";